module.exports = __webpack_public_path__ + "static/media/cancel.bc3e4b85.webp";